import React from 'react';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Text from '@amzn/meridian/text';
import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';

interface ErrorModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ isOpen, title, message, onClose }) => (
  <Modal title={title} open={isOpen} scrollContainer="viewport" aria-describedby="error-modal-description">
    <Text id="error-modal-description">{message}</Text>
    <ModalFooter>
      <Row alignmentHorizontal="end" widths="fit">
        <Button type="primary" size="small" onClick={onClose}>
          OK
        </Button>
      </Row>
    </ModalFooter>
  </Modal>
);

export default ErrorModal;
